export const adaptRegion = (data: IRegion): Region => {
	return {
		id: data.id,
		name: data.name,
		regionManager: data.region_manager,
		lastsync: data.lastsync,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptRegions = (data: IRegion[]): Region[] => {
	return data.map(adaptRegion);
};
